var getQAPI = function getQAPI() {
  var globalThis = null;
  if (typeof window !== "undefined") {
    globalThis = window;
  } else if (typeof global !== "undefined") {
    globalThis = global;
  } else {
    return {};
  }
  if (!globalThis.QAPI) {
    return {};
  }
  return globalThis.QAPI;
};
export default getQAPI;